import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Search from './search';
import LangSelect from './lang-select';
import MenuMobileRegularPtBr from './menu-mobile-regular-pt-br';
import MenuMobileProductsPtBr from './menu-mobile-products-pt-br';
import MenuMobileAboutPtBr from './menu-mobile-about-pt-br';
import MenuMobileRegularEnUs from './menu-mobile-regular-en-us';
import MenuMobileProductsEnUs from './menu-mobile-products-en-us';
import MenuMobileAboutEnUs from './menu-mobile-about-en-us';
import MenuMobileRegularEsEs from './menu-mobile-regular-es-es';
import MenuMobileProductsEsEs from './menu-mobile-products-es-es';
import MenuMobileAboutEsEs from './menu-mobile-about-es-es';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  position: fixed;
  background: #2D2D2C;
  border-top: 1px solid #D2AE82;
  bottom: 0;
  right: 0;
  left: 0;
  top: 76px;
  z-index: 4;
  display: none;
  flex-wrap: wrap;
  justify-content: center;
  padding: 40px 0;
  overflow: auto;
  &.active {
    display: flex;
  }
  @media (max-width: 980px) {
    #lang-select {
      border: 2px solid #D8B084;
      width: 160px;
      margin: 0 auto;
      height: 46px;
      ul {
        border: 2px solid #D8B084;
        border-radius: 3px 3px 0 0;
        border-bottom: 0;
        background: #2D2D2C;
        left: -2px;
      }
    }
  }
  .search {
    width: 100%;
    margin: 0 40px;
  }
  .menu-holder {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    menu {
      margin: 0;
      padding: 40px 0;
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      li {
        text-align: center;
        width: 100%;
        display: block;
        span,
        a {
          color: #D2AE82;
          font: bold italic 30px/60px 'Times new roman';
          text-decoration: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &.arrow-right {
            &:after {
              content: ' ';
              width: 0; 
              display: inline-block;
              margin-left: 20px;
              height: 0; 
              border-top: 6px solid transparent;
              border-bottom: 6px solid transparent;
              border-left: 6px solid #D2AE82;
            }
          }
          &.arrow-down {
            &:after {
              content: ' ';
              width: 0; 
              display: inline-block;
              margin-left: 20px;
              height: 0; 
              border-top: 6px solid #D2AE82;
              border-bottom: 6px solid transparent;
              border-left: 6px solid transparent;
              border-right: 6px solid transparent;
            }
          }
          &.arrow-left {
            &:before {
              content: ' ';
              width: 0; 
              display: inline-block;
              margin-right: 20px;
              height: 0; 
              border-top: 6px solid transparent;
              border-bottom: 6px solid transparent;
              border-right: 6px solid #D2AE82;
            }
          }
        }
        &.small {
          span,
          a {
            font: 18px/60px Montserrat;
          }
        }
      }
    }
  }
`

class MenuMobile extends Component {
  state = {
    menu: 'regular'
  }

  toggleMenuType = (type) => {
    this.setState({menu: type});
  }

  render = () => {
    const { language } = this.context;
    const { status } = this.props;
    return (
      <Container className={ status ? 'active' : '' }>
        <div className="menu-holder">
          <Search />
          {
            language === 'pt-br' && (
              <>
                { this.state.menu === 'regular' ? <MenuMobileRegularPtBr toggleMenuType={ this.toggleMenuType } /> : '' }
                { this.state.menu === 'products' ? <MenuMobileProductsPtBr toggleMenuType={ this.toggleMenuType } /> : '' }
                { this.state.menu === 'about' ? <MenuMobileAboutPtBr toggleMenuType={ this.toggleMenuType } /> : '' }
              </>
            )
          }
          {
            language === 'en-us' && (
              <>
                { this.state.menu === 'regular' ? <MenuMobileRegularEnUs toggleMenuType={ this.toggleMenuType } /> : '' }
                { this.state.menu === 'products' ? <MenuMobileProductsEnUs toggleMenuType={ this.toggleMenuType } /> : '' }
                { this.state.menu === 'about' ? <MenuMobileAboutEnUs toggleMenuType={ this.toggleMenuType } /> : '' }
              </>
            )
          }
          {
            language === 'es-es' && (
              <>
                { this.state.menu === 'regular' ? <MenuMobileRegularEsEs toggleMenuType={ this.toggleMenuType } /> : '' }
                { this.state.menu === 'products' ? <MenuMobileProductsEsEs toggleMenuType={ this.toggleMenuType } /> : '' }
                { this.state.menu === 'about' ? <MenuMobileAboutEsEs toggleMenuType={ this.toggleMenuType } /> : '' }
              </>
            )
          }
          <LangSelect />
        </div>
      </Container>   
    );
  }
}

MenuMobile.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

MenuMobile.contextType = LanguageContext;

export default MenuMobile;
